import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home/home.vue'),
    children: [
      {
        path: '/home/index',
        component: () => import('@/views/Home/index.vue'),
        meta: {
          title: '首页',
        },
      },

      {
        path: '/home/classify',
        component: () => import('@/views/Home/classify.vue'),
        meta: {
          title: '分类',
        },
      },
      {
        path: '/home/shopindex',
        component: () => import('@/views/shop/index.vue'),
        meta: {
          title: '齐家商城',
        },
      },
      {
        path: '/home/study',
        component: () => import('@/views/Home/study.vue'),
        meta: {
          title: '学习',
        },
      },
      {
        path: '/home/user',
        component: () => import('@/views/User/user.vue'),
        meta: {
          title: '个人',
        },
      },
    ],
  },
  {
    path: '/codepage',
    component: () => import('@/views/Home/codepage.vue'),
    meta: {
      title: '公众号二维码',
    },
  },
  {
    path: '/addresslist',
    component: () => import('@/views/shop/addresslist.vue'),
    meta: {
      title: '地址管理',
    },
  },
  {
    path: '/pays',
    component: () => import('@/views/shop/pays.vue'),
    meta: {
      title: '订单详情',
    },
  },

  {
    path: '/addressedit',
    component: () => import('@/views/shop/addressedit.vue'),
    meta: {
      title: '新增地址',
    },
  },
  {
    path: '/addressxg',
    component: () => import('@/views/shop/addressxg.vue'),
    meta: {
      title: '地址编辑',
    },
  },
  {
    path: '/shopinfo',
    component: () => import('@/views/shop/shopinfo.vue'),
    meta: {
      title: '商品详情',
    },
  },

  {
    path: '/dwhb',
    component: () => import('@/views/Home/dwhb.vue'),
    meta: {
      title: '动物黑帮',
    },
  },
  {
    path: '/application',
    component: () => import('@/views/Home/application.vue'),
    meta: {
      title: '长隆欢乐营线上报名',
    },
  },
  {
    path: '/paysuccess',
    component: () => import('@/views/shop/paysuccess.vue'),
    meta: {
      title: '齐家商城',
    },
  },

  {
    path: '/freenewpage',
    component: () => import('@/views/Home/freenewpage.vue'),
    meta: {
      title: '走进齐家',
    },
  },
  {
    path: '/freeinfopage',
    component: () => import('@/views/Home/freeinfopage.vue'),
    meta: {
      title: '课程详情',
    },
  },

  {
    path: '/heroinfo',
    component: () => import('@/views/Home/heroinfo.vue'),
    meta: {
      title: '伟人详情',
    },
  },
  {
    path: '/heroapps',
    component: () => import('@/views/Home/heroapps.vue'),
    meta: {
      title: '伟人圣哲',
    },
  },

  {
    path: '/hero',
    component: () => import('@/views/Home/hero.vue'),
    meta: {
      title: '伟人圣哲',
    },
  },
  {
    path: '/heroapp',
    component: () => import('@/views/Home/heroapp.vue'),
    meta: {
      title: '伟人圣哲',
    },
  },
  {
    path: '/heroinfoapp',
    component: () => import('@/views/Home/heroinfoapp.vue'),
    meta: {
      title: '伟人详情',
    },
  },
  {
    path: '/usecode/usecode',
    component: () => import('@/views/usecode/usecode.vue'),
    meta: {
      title: '获取用户信息',
    },
  },
  {
    path: '/registerDo',
    component: () => import('@/views/Login/registerDo.vue'),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/courseindex',
    component: () => import('@/views/Home/courseindex.vue'),
    meta: {
      title: '课程详情',
    },
  },
  {
    path: '/login',
    component: () => import('@/views/Login/login.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/search',
    component: () => import('@/views/Home/search.vue'),
    meta: {
      title: '课程搜索',
    },
  },

  {
    path: '/collect',
    component: () => import('@/views/User/collect.vue'),
    meta: {
      title: '我的收藏',
    },
  },

  {
    path: '/aggrements',
    component: () => import('@/views/User/aggrements.vue'),
    meta: {
      title: '隐私政策',
    },
  },
  {
    path: '/newaggrements',
    component: () => import('@/views/User/newaggrements.vue'),
    meta: {
      title: '隐私政策',
    },
  },
  {
    path: '/snewagg',
    component: () => import('@/views/User/snewagg.vue'),
    meta: {
      title: '隐私政策',
    },
  },

  {
    path: '/qjzx',
    component: () => import('@/views/Qjzx/qjzx.vue'),
    meta: {
      title: '齐家之星',
    },
  },
  {
    path: '/Qjzxphb',
    component: () => import('@/views/Qjzx/phb.vue'),
    meta: {
      title: '齐家之星排行榜',
    },
  },
  {
    path: '/lsb',
    component: () => import('@/views/Qjzx/lsb.vue'),
    meta: {
      title: '齐家之星历史榜',
    },
  },

  {
    path: '/qjzxinfo',
    component: () => import('@/views/Qjzx/qjzxinfo.vue'),
    meta: {
      title: '齐家之星',
    },
  },

  {
    path: '/freepage',
    component: () => import('@/views/Home/freepage.vue'),
    meta: {
      title: '齐家之学',
    },
  },

  {
    path: '/useraggrements',
    component: () => import('@/views/User/useraggrements.vue'),
    meta: {
      title: '服务协议',
    },
  },

  {
    path: '/txt',
    component: () => import('@/views/Home/txt.vue'),
    meta: {
      title: '我的收藏',
    },
  },
  {
    path: '/pay',
    component: () => import('@/views/Home/pay.vue'),
    meta: {
      title: '购买课程',
    },
  },
  {
    path: '/about',
    component: () => import('@/views/User/about.vue'),
    meta: {
      title: '关于我们',
    },
  },

  {
    path: '/forgetpass',
    component: () => import('@/views/Login/forgetpass.vue'),
    meta: {
      title: '忘记密码',
    },
  },
  {
    path: '/setup',
    component: () => import('@/views/User/setup.vue'),
    meta: {
      title: '设置',
    },
  },
  {
    path: '/ctapp',
    component: () => import('@/views/Home/ctapp.vue'),
    meta: {
      title: '庆国庆，颂盛世',
    },
  },
  {
    path: '/xzindex',
    component: () => import('@/views/User/xzindex.vue'),
    meta: {
      title: '齐家勋章',
    },
  },

  {
    path: '/ctgzh',
    component: () => import('@/views/Home/ctgzh.vue'),
    meta: {
      title: '庆国庆，颂盛世',
    },
  },

  {
    path: '/teacher',
    component: () => import('@/views/Home/teacher.vue'),
    meta: {
      title: '讲师介绍',
    },
  },
  {
    path: '/teacherinfo',
    component: () => import('@/views/Home/teacherinfo.vue'),
    meta: {
      title: '明星讲师',
    },
  },
  {
    path: '/qjtouurl',
    component: () => import('@/views/Home/qjtouurl.vue'),
    meta: {
      title: '跳转',
    },
  },

  {
    path: '/history',
    component: () => import('@/views/User/history.vue'),
    meta: {
      title: '历史观看',
    },
  },
  {
    path: '/xbindex',
    component: () => import('@/views/User/xbindex.vue'),
    meta: {
      title: '我的学币',
    },
  },
  {
    path: '/sayindex',
    component: () => import('@/views/rmjzt/sayindex.vue'),
    meta: {
      title: '个人主页',
    },
  },
  {
    path: '/rmregister',
    component: () => import('@/views/rmjzt/rmregister.vue'),
    meta: {
      title: '人脉金字塔注册',
    },
  },
  {
    path: '/editfriend',
    component: () => import('@/views/rmjzt/editfriend.vue'),
    meta: {
      title: '编辑好友',
    },
  },
  {
    path: '/rmzx',
    component: () => import('@/views/rmjzt/rmzx.vue'),
    meta: {
      title: '人脉之星',
    },
  },

  {
    path: '/fabu',
    component: () => import('@/views/rmjzt/fabu.vue'),
    meta: {
      title: '发表动态',
    },
  },
  {
    path: '/pyq',
    component: () => import('@/views/rmjzt/pyq.vue'),
    meta: {
      title: '用户信息',
    },
  },
  {
    path: '/inviteUser',
    component: () => import('@/views/rmjzt/inviteUser.vue'),
    meta: {
      title: '邀请用户',
    },
  },
  {
    path: '/allrm',
    component: () => import('@/views/rmjzt/allrm.vue'),
    meta: {
      title: '优秀人脉',
    },
  },
  {
    path: '/friend',
    component: () => import('@/views/rmjzt/friend.vue'),
    meta: {
      title: '我的好友',
    },
  },
  {
    path: '/zdyfz',
    component: () => import('@/views/rmjzt/zdyfz.vue'),
    meta: {
      title: '编辑分组',
    },
  },

  {
    path: '/plinfo',
    component: () => import('@/views/rmjzt/plinfo.vue'),
    meta: {
      title: '评论详情',
    },
  },

  {
    path: '/videoinfo',
    component: () => import('@/views/Home/videoinfo.vue'),
    meta: {
      title: '学员分享',
    },
  },
  {
    path: '/indexrm',
    component: () => import('@/views/rmjzt/indexrm.vue'),
    meta: {
      title: '首页',
    },
  },

  {
    path: '/hotpage',
    component: () => import('@/views/Home/hotpage.vue'),
    meta: {
      title: '齐家之学',
    },
  },

  {
    path: '/ykinfo',
    component: () => import('@/views/Home/ykinfo.vue'),
    meta: {
      title: '课程月刊',
    },
  },
  {
    path: '/Instructions',
    component: () => import('@/views/Home/Instructions.vue'),
    meta: {
      title: '人生地图',
    },
  },
  {
    path: '/newicon',
    component: () => import('@/views/Home/newicon.vue'),
    meta: {
      title: '齐家之学',
    },
  },
  {
    path: '/textttt',
    component: () => import('@/views/Home/textttt.vue'),
    meta: {
      title: '齐家之学',
    },
  },

  {
    path: '/teachercourse',
    component: () => import('@/views/Home/teachercourse.vue'),
    meta: {
      title: '讲师课程',
    },
  },
  {
    path: '/newcourse',
    component: () => import('@/views/Home/newcourse.vue'),
    meta: {
      title: '精选课程',
    },
  },
  {
    path: '/phb',
    component: () => import('@/views/Home/phb.vue'),
    meta: {
      title: '排行榜',
    },
  },
  {
    path: '/coursecode',
    component: () => import('@/views/User/coursecode.vue'),
    meta: {
      title: '线下课程详情',
    },
  },
  {
    path: '/coursecodewzh',
    component: () => import('@/views/User/coursecodewzh.vue'),
    meta: {
      title: '线下课程详情',
    },
  },
  {
    path: '/newhotpage',
    component: () => import('@/views/Home/newhotpage.vue'),
    meta: {
      title: '热门课程',
    },
  },
  {
    path: '/database',
    component: () => import('@/views/Home/database.vue'),
    meta: {
      title: '资料库',
    },
  },
  {
    path: '/text',
    component: () => import('@/views/User/text.vue'),
    meta: {
      title: '资料库',
    },
  },

  {
    path: '/qjttinfo',
    component: () => import('@/views/Home/qjttinfo.vue'),
    meta: {
      title: '齐家头条',
    },
  },
  {
    path: '/virtue',
    component: () => import('@/views/Qjzx/virtue.vue'),
    meta: {
      title: '爱能十八德',
    },
  },
  {
    path: '/music',
    component: () => import('@/views/Qjzx/music.vue'),
    meta: {
      title: '了了派之歌',
    },
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/home/index',
  },
]
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
